/*
 * @Author: showangjing showangjing@didiglobal.com
 * @Date: 2023-04-24 11:32:21
 * @LastEditors: showangjing showangjing@didiglobal.com
 * @LastEditTime: 2023-04-24 13:54:32
 * @FilePath: /fe-eshotel/src/components/notice/noticePopup.mpx
 * @Description: 公告弹窗
 */
 
<template>
  <es-popup
    wx:model="{{showAlert}}"
    position="bottom"
    closeable
    bind:close="closePopup"
  >
    <view class="tips-main">
      <view class="tips-container">
        <view class="header">
          <view class="tipsTitle">{{ info && info.window_title }}</view>
        </view>
        <scroll-view scroll-y="{{true}}" class="sroll-content-height">
          <view class="content">
            <view
              class="content-item"
              wx:for="{{info ? info.content_list : []}}"
              wx:key="index"
            >
              <view wx:if="{{item.title}}" class="item-title">
                <es-icon
                  name="exclamation-circle"
                  class="item-icon"
                  size="18"
                />
                <view>{{ item.title }}</view>
              </view>
              <view class="item-content">
                {{ item.content }}
              </view>
            </view>
          </view>
        </scroll-view>
        <view class="btn-bottom">
          <es-button
            custom-class="button"
            class="content-button"
            block
            type="info"
            bind:click="closePopup"
          >
            我知道了
          </es-button>
        </view>
      </view>
    </view>
  </es-popup>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'

  createComponent({
    props: {
      // 是否展示
      show: false,
      // 信息
      info: null
    },
    data: {},
    computed: {
      showAlert: {
        get() {
          return this.show
        },
        set() {}
      }
    },
    methods: {
      closePopup() {
        this.triggerEvent('close')
      }
    },
    mounted() {
      console.log('展示弹窗 notice')
    }
  })
</script>

<style lang="stylus" scoped>
  .custom-class
    top 120px
  .tips-main
    height 300px
  .header
    border-radius 16px 16px 0 0
    width 100%
    height 60px
    background #ffffff
    display flex
    align-items center
    justify-content center
    .tipsTitle
      text-align center
      width 217px
      line-height 25px
      font-family PingFangSC-Medium
      font-size 18px
      color #333333
  .tips-container
    background #FFFFFF
    border-radius 16px 16px 0 0
    padding-bottom 84px
  .close
    position absolute
    top 18px
    right 13px
    width 27px
    height 27px
    line-height 27px
    text-align center
  .sroll-content-height
    height 156px
  .content
    padding 0 20px
    box-sizing border-box
    border-radius 16px 16px 0 0
  .content-item
    font-family PingFangSC-Regular
    font-size 13px
    color #666666
    letter-spacing 0
    background #ffffff
    padding-bottom 15px
  .item-title
    display flex
    font-family PingFangSC-Medium
    font-size 16px
    color #1473ff
    letter-spacing 0
    line-height 18px
    align-items center
    .item-icon
      margin-right 5px
  .item-little-title
    font-family PingFangSC-Medium
    font-size 14px
    color #333333
    letter-spacing 0
    text-align justify
    line-height 14px
    margin-top 12px
    margin-bottom 8px
  .item-content
    font-size 14px
    color #333333
    letter-spacing 0
    text-align justify
    line-height 24px
    white-space pre-wrap
  .item-time
    font-size 12px
    color #333333
    letter-spacing 0
    text-align justify
    line-height 24px
  .content-item .blue
    color #1473FF
    margin-bottom 11px
  .legal
    background #FFF4EE
    border-radius 8px
    padding 10px 12px
    font-size 12px
    color #FF7D41
    letter-spacing 0
    text-align justify
    line-height 17px
    margin-bottom 32px
  .btn-bottom
    position fixed
    bottom 0
    background #ffffff
    width -webkit-fill-available
    padding 20px
  .content-button
    border-radius 8px
    font-size 16px
    font-weight 500
  .button
    border-radius 8px !important
    font-size 16px
    font-weight 500
</style>
<script name='json'>
  module.exports = {
    component: true,
    usingComponents: {
      'es-icon': '@didi/es-mpx-ui/lib/icon',
      'es-button': '@didi/es-mpx-ui/lib/button',
      'es-popup': '@didi/es-mpx-ui/lib/popup'
    }
  }
</script>